/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import ImprintPageMeta from "./ImprintPageMeta";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import Imprint from "@/src/components/Imprint/Imprint";

const ImprintPage = () => {
  return (
    <LayoutPublicRoutes>
      <ImprintPageMeta />
      <Imprint />
    </LayoutPublicRoutes>
  );
};

export default ImprintPage;
